import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setSelectedPackage } from '../../../../reducers/programRegistrationReducer'
import { displayWithCurrency } from '../../../../utility/currency'

import './PackageSelection.scss'

const PackageSelection = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const selectedPackage = useSelector(state => state.programRegistration.selectedPackage)
  const { coursePackages } = useSelector(state => state.programRegistration.enrollmentData)
  const { community } = useSelector(state => state.programPresentation.course)

  const handleSelectPackage = (pkg) => {
    if (selectedPackage.id !== pkg.id) {
      dispatch(setSelectedPackage(pkg))
    }
  }

  return (
    <div id='PackageSelection'>
      <h5 className='step-label'>{t('programs.registration.packageSelection.selectPackage')}</h5>
      <div className='d-flex flex-column package-card-options'>
        {coursePackages.map((pkg) => {
          const isSelected = selectedPackage.id === pkg.id

          return (
            <button
              key={pkg.id}
              type='button'
              onClick={() => handleSelectPackage(pkg)}
              className={classNames('package-card-option', { 'package-selected': isSelected })}
            >
              <span className='package-radio'>
                {isSelected && <span className='package-radio-dot' />}
              </span>
              <span className='package-content'>
                <span className='package-header'>
                  <span className='package-name'>{pkg.name}</span>
                  <span className='package-price'>{displayWithCurrency(pkg.price, community.currency)}</span>
                </span>
                <span className='package-description'>{pkg.description}</span>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default PackageSelection
